export default __webpack_public_path__ + "static/media/welcomeLandingbg-startup.62c2332d.png";